import { render, staticRenderFns } from "./ParticipantUserCardLoader.vue?vue&type=template&id=bbd60ce0&functional=true&"
import script from "./ParticipantUserCardLoader.vue?vue&type=script&lang=js&"
export * from "./ParticipantUserCardLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports